import { LicenseInfo } from '@mui/x-license-pro'

// The below key expires on 1st Sept 2027
LicenseInfo.setLicenseKey(
  `38052b54354e435658b6a9a9ea810ccfTz0xMzI1NDgsRT0xODE5ODQzMTk5MDAwLFM9cHJvLExNPWFubnVhbCxQVj1RMS0yMDI2LFE9MTAsS1Y9Mg==`
)
